const hostname = window.location.hostname;

let clientApiUrl;
let notificationApiUrl;
let taskApiUrl;
let userApiUrl;
let reportApiUrl;

// Add your dev Static Web App hostname below (get it from Azure Portal after creating the resource)
// Example: "proud-rock-012345.azurestaticapps.net"
const DEV_STATIC_WEB_APP_HOSTNAME = "salmon-ground-0e3035300.7.azurestaticapps.net";

if (hostname.includes("localhost")) {
  clientApiUrl = "http://localhost:7175/api";
  notificationApiUrl = "http://localhost:7236/api";
  taskApiUrl = "http://localhost:7174/api";
  userApiUrl = "http://localhost:7176/api";
  reportApiUrl = "http://localhost:7173/api";
} else if (
  hostname.includes("devhampi") ||
  (DEV_STATIC_WEB_APP_HOSTNAME && hostname.includes(DEV_STATIC_WEB_APP_HOSTNAME))
) {
  clientApiUrl = "https://fn-hampi-clientsvc-dev.azurewebsites.net/api";
  notificationApiUrl = "https://fn-hampi-notificationsvc-dev.azurewebsites.net/api";
  taskApiUrl = "https://fn-hampi-taskmanager.azurewebsites.net/api";
  userApiUrl = "https://fn-hampi-userservice-dev.azurewebsites.net/api";
  reportApiUrl = "https://fn-hampi-reportsvc-dev.azurewebsites.net/api";
} else {
  clientApiUrl = "https://fn-hampi-clientsvc-prod.azurewebsites.net/api";
  notificationApiUrl = "https://fn-hampi-notificationsvc-prod.azurewebsites.net/api";
  taskApiUrl = "https://fn-hampi-taskmanager-prod.azurewebsites.net/api";
  userApiUrl = "https://fn-hampi-usersvc-prod.azurewebsites.net/api";
  reportApiUrl = "https://fn-hampi-reportsvc-prod.azurewebsites.net/api";
}

export { clientApiUrl, notificationApiUrl, taskApiUrl, userApiUrl, reportApiUrl };

// Task 1 - Verify all the dev and prod endpoints. clientApiUrl and taskApiUrl for dev is verified.
